import reduxCrud from 'redux-crud';

const vehiclesReducers = reduxCrud.Map.reducersFor('vehicles', { key: 'id' });

export default vehiclesReducers;
